module.exports = __webpack_public_path__ + "static/media/research.def099a2.svg";